window.onSubmitPasswordEmail = function() {
    document.querySelector('form').submit();
}
